<template lang="pug">
  .notifications
</template>

<script>
import Vue from 'vue'
import Notification from '../Notification.vue'
import { CLEAR_NOTE_QUEUE } from 'vuex-store/mutation-types'
import { mapGetters } from 'vuex'

const NotificationComponent = Vue.extend(Notification)

const openNotification = (propsData = {
  title: '',
  message: '',
  type: '',
  direction: '',
  duration: 4500,
  container: '.notifications'
}) => {
  return new NotificationComponent({
    el: document.createElement('div'),
    propsData
  })
}

export default {
  components: {
    Notification
  },
  computed: {
    ...mapGetters([
      'notifications'
    ])
  },
  watch: {
    'notifications': {
      handler: function (notes) {
        notes.forEach(function (n) {
          openNotification({
            title: n.title,
            message: n.message,
            type: n.type
          })
        })
        this.$store.commit(CLEAR_NOTE_QUEUE)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// Notifications.vue?2b3bae68